import { Brand } from '@/lib/brands/contracts.ts';
import { Brands } from '@/lib/contants.ts';
import {
  CLUB_FUNESCOOP_EMPLEADOS_ID,
  CLUB_FUNESCOOP_EMPLEADOS_PRICE,
  CLUB_FUNESCOOP_ID,
  CLUB_FUNESCOOP_PRICE,
  CLUB_LA_MAQUINITA_ID,
  CLUB_LA_MAQUINITA_PRICE,
  CLUB_LA_NACION_ID,
  CLUB_LA_NACION_PRICE,
  CLUB_MASLOW_ID,
  CLUB_MASLOW_PRICE,
  CLUB_MOVIECLUB_ID,
  CLUB_MOVIECLUB_PRICE,
  CLUB_MOVISTAR_ID,
  CLUB_MOVISTAR_PRICE,
  CLUB_PERSONAL_PAY_ID,
  CLUB_PERSONAL_PAY_PRICE,
  CLUB_RIO_NEGRO_ID,
  CLUB_RIO_NEGRO_PRICE,
  CLUB_SANTANDER_ID,
  CLUB_SANTANDER_PRICE,
  CLUB_SWISS_MEDICAL_ID,
  CLUB_SWISS_MEDICAL_PRICE,
  CLUB_TELVISO_ID,
  CLUB_TELVISO_PRICE,
} from '@/lib/config.ts';
import santanderImg from '@/assets/brands/santander.jpg';
import clubLNImg from '@/assets/brands/club_la_nacion.jpeg';
import clubRioNegroImg from '@/assets/brands/club_rio_negro.png';
import movieClubImg from '@/assets/brands/movie-club.jpg';
import laMaquinitaImg from '@/assets/brands/la-maquinita.jpg';
import funescoopImg from '@/assets/brands/funescoop.jpg';
import clubMovistarImg from '@/assets/brands/club-movistar.jpg';
import clubPersonalPayImg from '@/assets/brands/club-personal-pay.png';
import telvisoImg from '@/assets/brands/logo_telviso_v2.png';
import maslowImg from '@/assets/brands/maslow.png';
import swissMedicalImg from '@/assets/brands/swiss-medical.png';

const currency = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
});

export const brands: Record<string, Brand> = {
  [Brands.SANTANDER]: {
    id: +CLUB_SANTANDER_ID,
    slug: Brands.SANTANDER,
    pageTitle: 'Alianza Santander',
    title: 'Beneficios Extra para Tarjeta Santander',
    description:
      '¡Asociate Ahora! y sumá mas beneficios a tu suscripción Movie Club',
    img: santanderImg,
    price: currency.format(CLUB_SANTANDER_PRICE),
    items: [
      {
        title: '2 entradas',
        description: <p>Para ver la peli que quieras, ¡el día que quieras!</p>,
      },
      {
        title: 'Descuentos en Candy',
        description: (
          <p>
            Anunciate como <strong>socio MovieClub</strong> antes de realizar tu
            compra para obtener el descuento.
          </p>
        ),
      },
      {
        title: 'Avant Premiere, Funciones Exclusivas',
        description: <p>Te invitamos a ser parte de las mejores pelis.</p>,
      },
      {
        title: 'Venta Anticipada',
        description: (
          <p>
            Tu lugar <strong>antes que nadie</strong> para esas pelis que todos
            quieren ver.
          </p>
        ),
      },
      {
        title: 'MoviePrice',
        description: (
          <p>
            Adquirí tu entrada a un precio exclusivo...{' '}
            <strong>¡todos los días!</strong>
          </p>
        ),
      },
    ],
    conditionsLink: '',
  },
  [Brands.CLUB_LA_NACION]: {
    id: +CLUB_LA_NACION_ID,
    slug: Brands.CLUB_LA_NACION,
    pageTitle: 'Alianza Club La Nación',
    title: 'Beneficios extra para socios Club La Nación',
    subTitle: '20% OFF en tu suscripción MovieClub por 1 año.',
    description:
      '¡Asociate Ahora! y sumá mas beneficios a tu suscripción Movie Club',
    img: clubLNImg,
    price: currency.format(CLUB_LA_NACION_PRICE),
    items: [
      {
        title: '2 entradas',
        description: <p>Para ver la peli que quieras, ¡el día que quieras!</p>,
      },
      {
        title: 'Descuentos en Candy',
        description: (
          <p>
            Anunciate como <strong>socio MovieClub</strong> antes de realizar tu
            compra para obtener el descuento.
          </p>
        ),
      },
      {
        title: 'Avant Premiere, Funciones Exclusivas',
        description: <p>Te invitamos a ser parte de las mejores pelis.</p>,
      },
      {
        title: 'Venta Anticipada',
        description: (
          <p>
            Tu lugar <strong>antes que nadie</strong> para esas pelis que todos
            quieren ver.
          </p>
        ),
      },
      {
        title: 'MoviePrice',
        description: (
          <p>
            Adquirí tu entrada a un precio exclusivo...{' '}
            <strong>¡todos los días!</strong>
          </p>
        ),
      },
    ],
    conditionsLink: '',
    extraField: {
      label: 'Nro. de socio Club La Nación (Sólo números)',
    },
  },
  [Brands.CLUB_RIO_NEGRO]: {
    id: +CLUB_RIO_NEGRO_ID,
    slug: Brands.CLUB_RIO_NEGRO,
    pageTitle: 'Alianza Club Río Negro',
    title: 'Beneficios extra para socios Club La Nación',
    subTitle: '20% OFF en tu suscripción MovieClub por 1 año.',
    description:
      '¡Asociate Ahora! y sumá mas beneficios a tu suscripción Movie Club',
    img: clubRioNegroImg,
    price: currency.format(CLUB_RIO_NEGRO_PRICE),
    items: [
      {
        title: '2 entradas',
        description: <p>Para ver la peli que quieras, ¡el día que quieras!</p>,
      },
      {
        title: 'Descuentos en Candy',
        description: (
          <p>
            Anunciate como <strong>socio MovieClub</strong> antes de realizar tu
            compra para obtener el descuento.
          </p>
        ),
      },
      {
        title: 'Avant Premiere, Funciones Exclusivas',
        description: <p>Te invitamos a ser parte de las mejores pelis.</p>,
      },
      {
        title: 'Venta Anticipada',
        description: (
          <p>
            Tu lugar <strong>antes que nadie</strong> para esas pelis que todos
            quieren ver.
          </p>
        ),
      },
      {
        title: 'MoviePrice',
        description: (
          <p>
            Adquirí tu entrada a un precio exclusivo...{' '}
            <strong>¡todos los días!</strong>
          </p>
        ),
      },
    ],
    conditionsLink: '',
    extraField: {
      label: 'Nro. de tarjeta de Club Río Negro',
    },
  },
  [Brands.MOVIECLUB]: {
    id: +CLUB_MOVIECLUB_ID,
    slug: Brands.MOVIECLUB,
    pageTitle: 'Socio MovieClub',
    title: '¿Querés disfrutar de beneficios exclusivos?',
    description: '¡Asociate Ahora! Entrá a tu nuevo Club y salí al Cine',
    img: movieClubImg,
    price: currency.format(CLUB_MOVIECLUB_PRICE),
    items: [
      {
        title: '2 entradas',
        description: <p>Para ver la peli que quieras, ¡el día que quieras!</p>,
      },
      {
        title: 'Descuentos en Candy',
        description: (
          <p>
            Anunciate como <strong>socio MovieClub</strong> antes de realizar tu
            compra para obtener el descuento.
          </p>
        ),
      },
      {
        title: 'Avant Premiere, Funciones Exclusivas',
        description: <p>Te invitamos a ser parte de las mejores pelis.</p>,
      },
      {
        title: 'Venta Anticipada',
        description: (
          <p>
            Tu lugar <strong>antes que nadie</strong> para esas pelis que todos
            quieren ver.
          </p>
        ),
      },
      {
        title: 'MoviePrice',
        description: (
          <p>
            Adquirí tu entrada a un precio exclusivo...{' '}
            <strong>¡todos los días!</strong>
          </p>
        ),
      },
    ],
    conditionsLink: '',
  },
  [Brands.FUNESCOOP]: {
    id: +CLUB_FUNESCOOP_ID,
    slug: Brands.FUNESCOOP,
    pageTitle: 'Alianza Funescoop',
    title: '¿Querés disfrutar de beneficios exclusivos?',
    description: '¡Asociate Ahora! Entrá a tu nuevo Club y salí al Cine',
    img: funescoopImg,
    price: currency.format(CLUB_FUNESCOOP_PRICE),
    items: [
      {
        title: 'Beneficios extra para clientes Funescoop',
        description: (
          <p>
            2 meses gratis + 50% OFF en tu suscripción MovieClub por 6 meses.
          </p>
        ),
      },
      {
        title: '2 entradas',
        description: <p>Para ver la peli que quieras, ¡el día que quieras!</p>,
      },
      {
        title: 'Descuentos en Candy',
        description: (
          <p>
            Anunciate como <strong>socio MovieClub</strong> antes de realizar tu
            compra para obtener el descuento.
          </p>
        ),
      },
      {
        title: 'Avant Premiere, Funciones Exclusivas',
        description: <p>Te invitamos a ser parte de las mejores pelis.</p>,
      },
      {
        title: 'Venta Anticipada',
        description: (
          <p>
            Tu lugar <strong>antes que nadie</strong> para esas pelis que todos
            quieren ver.
          </p>
        ),
      },
      {
        title: 'MoviePrice',
        description: (
          <p>
            Adquirí tu entrada a un precio exclusivo...{' '}
            <strong>¡todos los días!</strong>
          </p>
        ),
      },
    ],
    conditionsLink: '',
  },
  [Brands.FUNESCOOP_EMPLEADOS]: {
    id: +CLUB_FUNESCOOP_EMPLEADOS_ID,
    slug: Brands.FUNESCOOP_EMPLEADOS,
    pageTitle: 'Movieclub Funescoop Empleados',
    title: '¿Querés disfrutar de beneficios exclusivos?',
    description: '¡Asociate Ahora! Entrá a tu nuevo Club y salí al Cine',
    img: funescoopImg,
    price: currency.format(CLUB_FUNESCOOP_EMPLEADOS_PRICE),
    items: [
      {
        title: 'Beneficios extra para empleados Funescoop',
        description: (
          <p>
            4 meses gratis + 50% OFF en tu suscripción MovieClub por 9 meses.
          </p>
        ),
      },
      {
        title: '2 entradas',
        description: <p>Para ver la peli que quieras, ¡el día que quieras!</p>,
      },
      {
        title: 'Descuentos en Candy',
        description: (
          <p>
            Anunciate como <strong>socio MovieClub</strong> antes de realizar tu
            compra para obtener el descuento.
          </p>
        ),
      },
      {
        title: 'Avant Premiere, Funciones Exclusivas',
        description: <p>Te invitamos a ser parte de las mejores pelis.</p>,
      },
      {
        title: 'Venta Anticipada',
        description: (
          <p>
            Tu lugar <strong>antes que nadie</strong> para esas pelis que todos
            quieren ver.
          </p>
        ),
      },
      {
        title: 'MoviePrice',
        description: (
          <p>
            Adquirí tu entrada a un precio exclusivo...{' '}
            <strong>¡todos los días!</strong>
          </p>
        ),
      },
    ],
    conditionsLink: '',
  },
  [Brands.LA_MAQUINITA]: {
    id: +CLUB_LA_MAQUINITA_ID,
    slug: Brands.LA_MAQUINITA,
    pageTitle: 'Alianza La Maquinita Co.',
    title: '¿Querés disfrutar de beneficios exclusivos?',
    description: '¡Asociate Ahora! Entrá a tu nuevo Club y salí al Cine',
    img: laMaquinitaImg,
    price: currency.format(CLUB_LA_MAQUINITA_PRICE),
    items: [
      {
        title: 'Beneficios extra para clientes La Maquinita',
        description: <p>1 mes gratis + 20% OFF en tu suscripción MovieClub.</p>,
      },
      {
        title: '2 entradas',
        description: <p>Para ver la peli que quieras, ¡el día que quieras!</p>,
      },
      {
        title: 'Descuentos en Candy',
        description: (
          <p>
            Anunciate como <strong>socio MovieClub</strong> antes de realizar tu
            compra para obtener el descuento.
          </p>
        ),
      },
      {
        title: 'Avant Premiere, Funciones Exclusivas',
        description: <p>Te invitamos a ser parte de las mejores pelis.</p>,
      },
      {
        title: 'Venta Anticipada',
        description: (
          <p>
            Tu lugar <strong>antes que nadie</strong> para esas pelis que todos
            quieren ver.
          </p>
        ),
      },
      {
        title: 'MoviePrice',
        description: (
          <p>
            Adquirí tu entrada a un precio exclusivo...{' '}
            <strong>¡todos los días!</strong>
          </p>
        ),
      },
    ],
    conditionsLink: '',
  },
  [Brands.CLUB_MOVISTAR]: {
    id: +CLUB_MOVISTAR_ID,
    slug: Brands.CLUB_MOVISTAR,
    pageTitle: 'Club Movistar',
    title: '¿Querés disfrutar de beneficios exclusivos?',
    description: '¡Asociate Ahora! Entrá a tu nuevo Club y salí al Cine',
    img: clubMovistarImg,
    price: currency.format(CLUB_MOVISTAR_PRICE),
    items: [
      {
        title: 'Beneficios extra para socios Club Movistar',
        description: (
          <p>2 meses gratis + 25% OFF en tu suscripción MovieClub.</p>
        ),
      },
      {
        title: '2 entradas',
        description: <p>Para ver la peli que quieras, ¡el día que quieras!</p>,
      },
      {
        title: 'Descuentos en Candy',
        description: (
          <p>
            Anunciate como <strong>socio MovieClub</strong> antes de realizar tu
            compra para obtener el descuento.
          </p>
        ),
      },
      {
        title: 'Avant Premiere, Funciones Exclusivas',
        description: <p>Te invitamos a ser parte de las mejores pelis.</p>,
      },
      {
        title: 'Venta Anticipada',
        description: (
          <p>
            Tu lugar <strong>antes que nadie</strong> para esas pelis que todos
            quieren ver.
          </p>
        ),
      },
      {
        title: 'MoviePrice',
        description: (
          <p>
            Adquirí tu entrada a un precio exclusivo...{' '}
            <strong>¡todos los días!</strong>
          </p>
        ),
      },
    ],
    conditionsLink: '',
  },
  [Brands.PERSONAL_PAY]: {
    id: +CLUB_PERSONAL_PAY_ID,
    slug: Brands.PERSONAL_PAY,
    pageTitle: 'Socio Personal Pay',
    title: '¿Querés disfrutar de beneficios exclusivos?',
    description: '¡Asociate Ahora! Entrá a tu nuevo Club y salí al Cine',
    img: clubPersonalPayImg,
    price: currency.format(CLUB_PERSONAL_PAY_PRICE),
    items: [
      {
        title: '¿Cuáles son tus beneficios siendo socio MovieClub?',
        description: (
          <>
            <ul style={{ listStyleType: 'disc', marginLeft: '1.5em' }}>
              <li>
                2 entradas por mes válidas en salas tradicionales y MONSTER
                SCREEN, en formato 2D y 3D.
              </li>
              <li>
                Descuentos en dulcería: 35% off combos POP, 20% off todos los
                combos, 20% off combos Premium.
              </li>
              <li>
                Movieprice: 50% de descuento todos los días en salas
                tradicionales y Monster Screen, en formato 2D y 3D. 50% de
                descuento en salas 4D de lunes a viernes.
              </li>
              <li>
                Invitaciones a Premieres y eventos especiales. Recibe pases
                dobles para disfrutar de funciones especiales antes que nadie.
              </li>
            </ul>
            <p className="text-muted-foreground mt-1 text-sm">
              Beneficios válidos en todos los complejos Cinépolis.
            </p>
          </>
        ),
      },
      {
        title: 'Beneficios con Personal Pay',
        description: (
          <ul style={{ listStyleType: 'disc', marginLeft: '1.5em' }}>
            <li>2 meses sin cargo en suscripción a MovieClub.</li>
            <li>
              50% de descuento sobre el valor de la suscripción durante el
              primer año.
            </li>
            <li>Exclusivo abonando con tarjeta física Visa Personal Pay.</li>
            <li>Aplicación: Todos los días.</li>
            <li>Sin tope de descuento.</li>
          </ul>
        ),
      },
    ],
    conditionsLink: '',
    validityPeriod: 'Válido desde el 15/11/2025 hasta el 30/10/2026',
  },
  [Brands.TELVISO]: {
    id: +CLUB_TELVISO_ID,
    slug: Brands.TELVISO,
    pageTitle: 'Alianza Telviso',
    title: 'Beneficios extra para clientes Telviso',
    description:
      '¡Asociate Ahora! y sumá mas beneficios a tu suscripción Movie Club',
    img: telvisoImg,
    price: currency.format(CLUB_TELVISO_PRICE),
    items: [
      {
        title: '¿Cuáles son tus beneficios siendo socio Telviso?',
        description: (
          <>
            <ul style={{ listStyleType: 'disc', marginLeft: '1.5em' }}>
              <li>
                2 entradas por mes válidas en salas tradicionales y MONSTER
                SCREEN, en formato 2D y 3D.
              </li>
              <li>
                Descuentos en dulcería: 35% off combos POP, 20% off todos los
                combos, 20% off combos Premium.
              </li>
              <li>
                Movieprice: 50% de descuento todos los días en salas
                tradicionales y Monster Screen, en formato 2D y 3D. 50% de
                descuento en salas 4D de lunes a viernes.
              </li>
              <li>
                Invitaciones a Premieres y eventos especiales. Recibe pases
                dobles para disfrutar de funciones especiales antes que nadie.
              </li>
            </ul>
            <p className="text-muted-foreground mt-1 text-sm">
              Beneficios válidos en todos los complejos Cinépolis.
            </p>
          </>
        ),
      },
      {
        title: 'Beneficios clientes Telviso',
        description: (
          <ul style={{ listStyleType: 'disc', marginLeft: '1.5em' }}>
            <li>2 meses sin cargo en suscripción a MovieClub.</li>
            <li>
              50% de descuento sobre el valor de la suscripción durante 6 meses.
            </li>
          </ul>
        ),
      },
    ],
    conditionsLink: '',
    extraField: {
      label: 'Nº cliente Telviso:',
    },
  },
  [Brands.MASLOW]: {
    id: +CLUB_MASLOW_ID,
    slug: Brands.MASLOW,
    pageTitle: 'Alianza Maslow',
    title: 'Beneficios extra para clientes Maslow',
    description:
      '¡Asociate Ahora! y sumá mas beneficios a tu suscripción Movie Club',
    img: maslowImg,
    price: currency.format(CLUB_MASLOW_PRICE),
    items: [
      {
        title: 'Beneficios extra para clientes Maslow',
        description: (
          <p>
            2 meses gratis + 50% OFF en tu suscripción MovieClub por 6 meses.
          </p>
        ),
      },
      {
        title: '2 entradas',
        description: <p>Para ver la peli que quieras, ¡el día que quieras!</p>,
      },
      {
        title: 'Descuentos en Candy',
        description: (
          <p>
            Anunciate como <strong>socio MovieClub</strong> antes de realizar tu
            compra para obtener el descuento.
          </p>
        ),
      },
      {
        title: 'Avant Premiere, Funciones Exclusivas',
        description: <p>Te invitamos a ser parte de las mejores pelis.</p>,
      },
      {
        title: 'Venta Anticipada',
        description: (
          <p>
            Tu lugar <strong>antes que nadie</strong> para esas pelis que todos
            quieren ver.
          </p>
        ),
      },
      {
        title: 'MoviePrice',
        description: (
          <p>
            Adquirí tu entrada a un precio exclusivo...{' '}
            <strong>¡todos los días!</strong>
          </p>
        ),
      },
    ],
    conditionsLink: '',
  },
  [Brands.SWISS_MEDICAL]: {
    id: +CLUB_SWISS_MEDICAL_ID,
    slug: Brands.SWISS_MEDICAL,
    pageTitle: 'Alianza Swiss Medical',
    title: 'Beneficios extra para clientes Swiss Medical',
    description:
      '¡Asociate Ahora! y sumá mas beneficios a tu suscripción Movie Club',
    img: swissMedicalImg,
    price: currency.format(CLUB_SWISS_MEDICAL_PRICE),
    items: [
      {
        title: 'Beneficios extra para clientes Swiss Medical',
        description: (
          <p>
            2 meses gratis + 50% OFF en tu suscripción MovieClub por 6 meses.
          </p>
        ),
      },
      {
        title: '2 entradas',
        description: <p>Para ver la peli que quieras, ¡el día que quieras!</p>,
      },
      {
        title: 'Descuentos en Candy',
        description: (
          <p>
            Anunciate como <strong>socio MovieClub</strong> antes de realizar tu
            compra para obtener el descuento.
          </p>
        ),
      },
      {
        title: 'Avant Premiere, Funciones Exclusivas',
        description: <p>Te invitamos a ser parte de las mejores pelis.</p>,
      },
      {
        title: 'Venta Anticipada',
        description: (
          <p>
            Tu lugar <strong>antes que nadie</strong> para esas pelis que todos
            quieren ver.
          </p>
        ),
      },
      {
        title: 'MoviePrice',
        description: (
          <p>
            Adquirí tu entrada a un precio exclusivo...{' '}
            <strong>¡todos los días!</strong>
          </p>
        ),
      },
    ],
    conditionsLink: '',
  },
};

export const getBrandBySlug = (slug: string): Brand | undefined => {
  return brands[slug];
};

export const getBrandById = (id: number): Brand | undefined => {
  return Object.values(brands).find((brand) => brand.id === id);
};
